const moment = require('moment');

export function extractPlayersFromBookings(relatedBookings = []) {
    const players = [];

    for (let i = 0; i < relatedBookings.length && players.length < 4; i++) {
        const booking = relatedBookings[i];

        for (let j = 1; j <= 4; j++) {
            const playerKey = `Player${j}`;
            const userTypeKey = `UserType${j}`;
            const playerName = booking?.[playerKey];
            const playerType = booking?.[userTypeKey];

            if (playerName) {
                players.push({
                    name: playerName,
                    type: playerType
                });

                if (players.length === 4) break; // stop once we have 4
            }
        }
    }

    return players;
}


export function showSlot(row) {
    if (!row.DiscountLabel) return row.Slot;

    return `${row.Slot}<span class="badge badge-danger" data-toggle="kt-popover" data-trigger="hover click" data-placement="top" data-original-title="Dynamic Pricing" data-content="${row.DiscountLabel}">${row.DiscountLabel}</span>`;
}

export function showBookStatus(row) {
    if (row.Status == "Available") {
        return "<div class='badge badge-success'><span>Available</span></div>";
    } else if(row.Status == 'Remaining'){
        return '<div class="badge badge-info"><span>' + `${4 - row.UserCount } Available` + '</span></div>';
    } else {
        return '<div class="badge badge-danger"><span>' + row.Status + '</span></div>';
    }
}


export function showBookPlayer(row, index) {
    const players = extractPlayersFromBookings(row.RelatedBookings);
    const player = players[index];
    return player
        ? `<span class='kt-badge kt-badge--${
            player.type === "User" ? 'success' :
            (player.type === "Guest" || player.type === "UsersGuest") ? 'warning' : 'danger'
        } kt-badge--dot'></span>&nbsp;&nbsp;${player.name}`
        : '';
}


export function showEditButton(row, sheet = []) {
    let optString = '';
    // const formattedDate = moment($('#txtDate').val(), 'DD/MM/YYYY').format('DD-MMM-YYYY');
    // const isEdit = moment(moment(sheet.ServerDate).format('DD-MMM-YYYY')).isSameOrBefore(formattedDate) && (row.Status === 'Available' || row.Status === 'Booked');
    const isEdit = (row.Status === 'Available' || row.Status === 'Booked');
    
    optString += '<center>'
    
    if (row.Comment) optString += `<button type="button" class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xxs mr-1" data-toggle="kt-popover"  data-trigger="hover click" data-placement="left" data-original-title="Comments" data-content="${row.Comment}"><i class="fa fa-info"></i></button>`;
    if (isEdit) optString += `<button type="button"  class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xxs btn-edit"><i class="flaticon2-edit"></i></button>`;
    
    optString += '</center>'
    
    return optString;
}